import { logger } from '~/features-shared/libs/utils/logger'

/**
 * Convert time (HH:MM:SS) into milliseconds
 * @param time HH:MM:SS
 * @example convertTime("01:24:59") // -> 5099000
 */
export function timeToMilliseconds(time: string): number {
  const parts = time
    .split(':')
    .map(el => Number.parseInt(el))

  if (parts.length !== 3) {
    logger.error(new Error('Invalid time format'))
    return 0
  }

  const [hours, minutes, seconds] = parts

  // Calculate total milliseconds
  const milliseconds = ((hours * 60 * 60) + (minutes * 60) + seconds) * 1000

  return milliseconds
}
